import { Injectable } from '@angular/core';
import { PackingBoxViewAuthService } from '../../../views/packing-box/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LidPackingBoxAuthService extends PackingBoxViewAuthService {
  Deparment = 'Lids';
  override createLabel(): boolean {
    return this.lookForRolesNeeded([
      'Admin',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'LidLabel',
      'LidQc',
    ]);
  }

  override createCustomLabel(): boolean {
    return !this.onlyViewers(['Lid']);
  }
}
